import { render, staticRenderFns } from "./HomeApoio.vue?vue&type=template&id=4ea0c4ac&scoped=true"
import script from "./HomeApoio.vue?vue&type=script&lang=js"
export * from "./HomeApoio.vue?vue&type=script&lang=js"
import style0 from "./HomeApoio.vue?vue&type=style&index=0&id=4ea0c4ac&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ea0c4ac",
  null
  
)

export default component.exports